export default "__VITE_ASSET__296359e8__"